import { status } from '../../helpers'

const getProductStoreDefaultState = () => {
  return {
    loadProducts: status.INITIALIZED,
    productList: [],
    variant: [],
    loadProductDetails: status.INITIALIZED,
    productNotFound: false,
    productDetails: {},
    productVariants: [],
    productVariantsImages: [],
    loadBundles: status.INITIALIZED,
    bundlesList: [],
    loadBundleDetails: status.INITIALIZED,
    bundleNotFound: false,
    bundleDetails: {},
    bundleItems: [],
    variantTypes: [],
    variantColors: [],
    variantSizes: [],
    variantDictionary: [],
    defaultSelection: {},
    errors: []
  }
}

export default getProductStoreDefaultState
